import React, { useState, useEffect } from "react";
import { IoAddCircleOutline } from "react-icons/io5";
import Select from "react-select";
import {
  customSelectStyles,
  customSelectComponents,
} from "../../utils/InputStyles";
import api from "../../utils/apiAuth";

const LanguageModal = ({ initialLanguages, onLanguagesUpdate }) => {
  const [languageOptions, setLanguageOptions] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchLanguages = async () => {
      try {
        const response = await api.get("/locations/turkish-languages");

        if (!response.data?.data || !Array.isArray(response.data.data)) {
          console.error("API yanıtı beklenen formatta değil");
          setLanguageOptions([]);
          return;
        }

        const formattedOptions = response.data.data
          .filter((lang) => typeof lang === "string" && lang.trim() !== "")
          .map((lang) => ({
            value: lang,
            label: lang,
          }))
          .sort((a, b) => a.label.localeCompare(b.label, "tr")); // Türkçe alfabetik sıralama

        setLanguageOptions(formattedOptions);
      } catch (error) {
        console.error("Diller yüklenirken hata oluştu:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchLanguages();
  }, []);

  const levelOptions = [
    { value: "Başlangıç", label: "Başlangıç" },
    { value: "Orta", label: "Orta" },
    { value: "İleri", label: "İleri" },
  ];

  const [languageLevels, setLanguageLevels] = useState(() => {
    if (initialLanguages && initialLanguages.length > 0) {
      return initialLanguages;
    }
    return [{ language: "", level: "" }];
  });

  const handleAddLanguage = () => {
    setLanguageLevels([...languageLevels, { language: "", level: "" }]);
  };

  const handleLanguageChange = (index, field, value) => {
    const updatedLanguages = [...languageLevels];
    updatedLanguages[index] = { ...updatedLanguages[index], [field]: value };
    setLanguageLevels(updatedLanguages);
    onLanguagesUpdate(updatedLanguages);
  };

  const handleRemoveLanguage = (index) => {
    const updatedLanguages = languageLevels.filter((_, i) => i !== index);
    setLanguageLevels(updatedLanguages);
    onLanguagesUpdate(updatedLanguages);
  };

  return (
    <div>
      <div className="flex flex-col gap-4 sm:overflow-visible overflow-y-auto sm:max-h-none max-h-[70vh]">
        {languageLevels.map((langLevel, index) => (
          <div
            key={index}
            className="grid grid-cols-1 sm:grid-cols-2 gap-4 relative sm:border-none border-b border-gray-200 pb-2 mb-2 last:border-b-0"
          >
            <div className="form-group">
              <label htmlFor={`language-${index}`} className="label-edit">
                Dil Seçiniz
              </label>
              <Select
                options={languageOptions}
                value={
                  languageOptions.find(
                    (option) => option.value === langLevel.language
                  ) || null
                }
                onChange={(selectedOption) =>
                  handleLanguageChange(
                    index,
                    "language",
                    selectedOption ? selectedOption.value : ""
                  )
                }
                placeholder={loading ? "Yükleniyor..." : "Dil seçiniz"}
                isDisabled={loading}
                styles={{
                  ...customSelectStyles,
                  menu: (base) => ({
                    ...base,
                    position: "absolute",
                    width: "calc(100% - 8px)",
                    left: "4px",
                    right: "4px",
                  }),
                  container: (base) => ({
                    ...base,
                  }),
                }}
                components={customSelectComponents}
                id={`language-${index}`}
                menuPortalTarget={document.body}
                menuPosition="fixed"
              />
            </div>
            <div className="form-group relative">
              <label htmlFor={`level-${index}`} className="label-edit">
                Dil Seviyesi
              </label>
              <div className="flex gap-2">
                <div className="flex-1">
                  <Select
                    options={levelOptions}
                    value={
                      levelOptions.find(
                        (option) => option.value === langLevel.level
                      ) || null
                    }
                    onChange={(selectedOption) =>
                      handleLanguageChange(
                        index,
                        "level",
                        selectedOption ? selectedOption.value : ""
                      )
                    }
                    placeholder="Seviye seçiniz"
                    styles={{
                      ...customSelectStyles,
                      menu: (base) => ({
                        ...base,
                        position: "absolute",
                        width: "calc(100% - 8px)",
                        left: "4px",
                        right: "4px",
                      }),
                      container: (base) => ({
                        ...base,
                      }),
                    }}
                    components={customSelectComponents}
                    id={`level-${index}`}
                    menuPortalTarget={document.body}
                    menuPosition="fixed"
                  />
                </div>
                {languageLevels.length > 1 && (
                  <button
                    type="button"
                    onClick={() => handleRemoveLanguage(index)}
                    className="text-errorRed text-xl sm:self-end sm:mb-2 absolute sm:relative -top-1 right-0"
                    aria-label={`Dil ${index + 1}'i kaldır`}
                  >
                    −
                  </button>
                )}
              </div>
            </div>
          </div>
        ))}
        <div className="flex items-center justify-end text-success mt-4">
          <button
            type="button"
            onClick={handleAddLanguage}
            className="flex items-center gap-2"
            aria-label="Dil ekle"
          >
            <IoAddCircleOutline className="text-xl" />
            <span>Dil Ekle</span>
          </button>
        </div>
        <input
          type="hidden"
          name="languages"
          value={JSON.stringify(languageLevels)}
        />
      </div>
    </div>
  );
};

export default React.memo(LanguageModal);
